module.exports = __webpack_public_path__ + "img/under_developement.d5ddf2fa.jpg";